import React from "react";
import { FaNetworkWired } from "react-icons/fa";
import { BsCameraVideoFill, BsMicFill } from "react-icons/bs";
import { HiDocumentCheck } from "react-icons/hi2";
import { IoWarning } from "react-icons/io5";

const ProctorInstructions = () => {
  return (
    <div className="status-section instructions">
      <h3>Proctor Instructions</h3>
      <div className="instruction-container">
        <ul className="instruction-list">
          <li>
            <FaNetworkWired className="instruction-icon" />
            Ensure stable internet connection
          </li>
          <li>
            <BsCameraVideoFill className="instruction-icon" />
            Check camera and microphone access
          </li>
          <li>
            <HiDocumentCheck className="instruction-icon" />
            Monitor student activities in real-time
          </li>
          <li>
            <IoWarning className="instruction-icon" />
            Respond to behavioral alerts promptly
          </li>
          <li>
            <BsMicFill className="instruction-icon" />
            Use chat for student communication
          </li>
        </ul>
        <div className="instruction-note">
          <IoWarning className="note-icon" />
          <p>
            Note: Please ensure all system requirements are met before starting
            the session.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProctorInstructions;
